import { Controller } from '@hotwired/stimulus';

export default class CertificateTypeOfStudentCard extends Controller {
  static targets = [
    'reasonKind',
    'reasonDetail'
  ];

  connect() {
    this.reasonKindChanged();
  }

  reasonKindChanged() {
    this.reasonDetailTarget.disabled = this.reasonKindTarget.value !== 'other';
  }
}
